import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

import { initials } from "./helpers";

interface AvatarProps {
  /** Nombre completo: da las iniciales y el texto alternativo. */
  name: string;
  src?: string | null;
  /** Diámetro en px (22–64). */
  size?: number;
  /** `team` es alguien del equipo (verde Intmueble); `neutral`, un contacto. */
  tone?: "neutral" | "team";
  /** Distintivo abajo a la derecha, p. ej. el ícono del canal. */
  badge?: ReactNode;
  className?: string;
}

export function Avatar({
  name,
  src,
  size = 32,
  tone = "neutral",
  badge,
  className,
}: AvatarProps) {
  return (
    <span
      className={cn("relative inline-block shrink-0", className)}
      style={{ width: size, height: size }}
    >
      {src ? (
        <img src={src} alt={name} className="size-full rounded-full object-cover" />
      ) : (
        <span
          role="img"
          aria-label={name}
          className={cn(
            "grid size-full place-items-center rounded-full font-semibold",
            tone === "team"
              ? "bg-human text-rail-foreground"
              : "bg-surface-muted text-foreground",
          )}
          style={{ fontSize: Math.round(size / 2.8) }}
        >
          {initials(name)}
        </span>
      )}
      {badge && (
        <span className="bg-rail absolute -right-0.5 -bottom-0.5 grid size-[18px] place-items-center rounded-full">
          {badge}
        </span>
      )}
    </span>
  );
}
